import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 COREANO EXPRESSO™',
  ideal: 'Chiunque voglia capire il coreano da zero, senza aver mai studiato lingue prima',
  was: '54€',
  now: '27€',
  features: ['6 Tomi Completi (120+ pagine)', 'Hangeul da zero, spiegato visivamente', 'Espressioni reali K-Drama & K-Pop', 'Routine di 60 minuti con progresso visibile', '5 Bonus Gratuiti inclusi', 'Garanzia di soddisfazione 7 giorni', 'Accesso a vita & aggiornamenti gratuiti'],
  cta: 'Ottieni Coreano Expresso'
};
const trust = [{
  icon: LockIcon,
  label: 'Pagamento 100% Sicuro'
}, {
  icon: ZapIcon,
  label: 'Accesso Istantaneo'
}, {
  icon: CreditCardIcon,
  label: 'Carta di Credito / Debito'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Prezzo" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-151" data-mp="3w08g2dow7wd0">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-152" data-mp="4s4ab7stylgb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.45)]" data-id="element-153" data-mp="9s8rz15h5m84">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-154" data-mp="3n5tz86opsdrs">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-155" data-mp="3ryn20p0mhc18">
            <span className="font-semibold text-plum/80" data-id="element-156" data-mp="2uippxpil9da7">Ideale per:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-157" data-mp="2zhau200yoh3x">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "35px"
          }} data-id="element-158" data-mp="2zg9g9nsk9gii">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "80px",
            paddingBottom: "26px",
            fontFamily: "Cinzel, serif",
            paddingTop: "20px"
          }} data-id="element-159" data-mp="2rf1ue22t9i7b">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-160" data-mp="315wep0why7q4">
              Pagamento unico · Accesso illimitato
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-161" data-mp="28i0nuctlza19">
              Il pagamento sarà elaborato nella tua valuta locale.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-162" data-mp="23kqmpzwux9xl">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-163" data-mp="2ihre22b4z2vj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-164" data-mp="2dgaimmbf88mc" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-165" data-mp="3ow8wr4lghkuf">
            <CTAButton size="md" data-id="element-166" data-mp="3ovqqrg8zrs9b">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-167" data-mp="a435q49qsoe">
            Risparmi 27€ (50% di sconto)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-168" data-mp="5artsaol57i3">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-169" data-mp="3rgyjev7jo3q2">
                <Icon className="h-4 w-4 text-grape" data-id="element-170" data-mp="j26ecly55gr9" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-171" data-mp="o22lgu24xob1" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-172" data-mp="a8tfl3debkx9">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-173" data-mp="e8lo5g2shr2m" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-174" data-mp="11zhf6azf8i8t">
            <span className="font-display font-bold text-plum" data-id="element-175" data-mp="16qfup8cl5cb0">
              🛡️ Garanzia di soddisfazione 7 giorni.
            </span>{' '}
            Se nei primi 7 giorni pensi che l'ebook non corrisponda a ciò che ti serve o non ti dia
            la spinta che cercavi, chiedi il rimborso e ti restituiamo il 100% dei tuoi soldi.
            Vogliamo che impari in totale tranquillità, senza rischi.
          </p>
        </div>
      </div>
    </section>;
}